/* tslint:disable */
/* eslint-disable */
/**
 * Resource server API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { CarePlanPositionAdditionalDoctorDto } from './care-plan-position-additional-doctor-dto';
import { CarePlanSessionVisitDto } from './care-plan-session-visit-dto';
import { DoctorBasicDto } from './doctor-basic-dto';
import { DoctorWorkPlaceDto } from './doctor-work-place-dto';

/**
 * 
 * @export
 * @interface CarePlanPositionDto
 */
export interface CarePlanPositionDto {
    /**
     * 
     * @type {Array<CarePlanPositionAdditionalDoctorDto>}
     * @memberof CarePlanPositionDto
     */
    'additionalDoctors'?: Array<CarePlanPositionAdditionalDoctorDto>;
    /**
     * 
     * @type {boolean}
     * @memberof CarePlanPositionDto
     */
    'availableToChange'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof CarePlanPositionDto
     */
    'blockRescheduling': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof CarePlanPositionDto
     */
    'cancelled'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof CarePlanPositionDto
     */
    'description'?: string;
    /**
     * 
     * @type {DoctorBasicDto}
     * @memberof CarePlanPositionDto
     */
    'doctor'?: DoctorBasicDto;
    /**
     * 
     * @type {boolean}
     * @memberof CarePlanPositionDto
     */
    'done'?: boolean;
    /**
     * 
     * @type {number}
     * @memberof CarePlanPositionDto
     */
    'id': number;
    /**
     * 
     * @type {number}
     * @memberof CarePlanPositionDto
     */
    'invoiceId'?: number;
    /**
     * 
     * @type {string}
     * @memberof CarePlanPositionDto
     */
    'medicalService'?: CarePlanPositionDtoMedicalServiceEnum;
    /**
     * 
     * @type {string}
     * @memberof CarePlanPositionDto
     */
    'medicalServiceSubType'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof CarePlanPositionDto
     */
    'paid'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof CarePlanPositionDto
     */
    'paymentMarking'?: CarePlanPositionDtoPaymentMarkingEnum;
    /**
     * 
     * @type {string}
     * @memberof CarePlanPositionDto
     */
    'publicId'?: string;
    /**
     * 
     * @type {CarePlanSessionVisitDto}
     * @memberof CarePlanPositionDto
     */
    'sessionVisit'?: CarePlanSessionVisitDto;
    /**
     * 
     * @type {string}
     * @memberof CarePlanPositionDto
     */
    'timeFrom': string;
    /**
     * 
     * @type {string}
     * @memberof CarePlanPositionDto
     */
    'timeTo'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof CarePlanPositionDto
     */
    'toMove'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof CarePlanPositionDto
     */
    'type': CarePlanPositionDtoTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof CarePlanPositionDto
     */
    'visitPackageCode'?: string;
    /**
     * 
     * @type {DoctorWorkPlaceDto}
     * @memberof CarePlanPositionDto
     */
    'visitPlace'?: DoctorWorkPlaceDto;
    /**
     * 
     * @type {string}
     * @memberof CarePlanPositionDto
     */
    'visitType'?: CarePlanPositionDtoVisitTypeEnum;
}

/**
    * @export
    * @enum {string}
    */
export enum CarePlanPositionDtoMedicalServiceEnum {
    Visit0 = 'VISIT_0',
    Visit1 = 'VISIT_1',
    StandardVisit = 'STANDARD_VISIT',
    StandardVisit15 = 'STANDARD_VISIT_15',
    FollowupVisit = 'FOLLOWUP_VISIT',
    Message = 'MESSAGE',
    Prescription = 'PRESCRIPTION',
    AbsentConsultation = 'ABSENT_CONSULTATION',
    NeurosurgeonConsultation = 'NEUROSURGEON_CONSULTATION',
    NeuropsychologistConsultation = 'NEUROPSYCHOLOGIST_CONSULTATION',
    NeurologopedistConsultation = 'NEUROLOGOPEDIST_CONSULTATION',
    PsychiatristConsultation = 'PSYCHIATRIST_CONSULTATION',
    GeneticistConsultation = 'GENETICIST_CONSULTATION',
    EpileptologistConsultation = 'EPILEPTOLOGIST_CONSULTATION',
    NeurologistConsultation = 'NEUROLOGIST_CONSULTATION',
    DieticianConsultation = 'DIETICIAN_CONSULTATION',
    VnsConsultation = 'VNS_CONSULTATION',
    MetabolicConsultation = 'METABOLIC_CONSULTATION',
    SleepDisturbanceConsultation = 'SLEEP_DISTURBANCE_CONSULTATION',
    CaseConference = 'CASE_CONFERENCE',
    AdhdConsultation = 'ADHD_CONSULTATION',
    PsychotherapyConsultation = 'PSYCHOTHERAPY_CONSULTATION',
    TmsQualificationConsultation = 'TMS_QUALIFICATION_CONSULTATION',
    TmsInductionConsultation = 'TMS_INDUCTION_CONSULTATION',
    Tms15MConsultation = 'TMS_15M_CONSULTATION',
    Tms30MConsultation = 'TMS_30M_CONSULTATION',
    Tms45MConsultation = 'TMS_45M_CONSULTATION',
    EegConsultation = 'EEG_CONSULTATION',
    VeegNightConsultation = 'VEEG_NIGHT_CONSULTATION',
    VeegDayConsultation = 'VEEG_DAY_CONSULTATION',
    VeegOnStandbyConsultation1H = 'VEEG_ON_STANDBY_CONSULTATION_1H',
    VeegOnStandbyConsultation2H = 'VEEG_ON_STANDBY_CONSULTATION_2H',
    VeegOnStandbyConsultation6H = 'VEEG_ON_STANDBY_CONSULTATION_6H',
    VeegDuringSleepConsultation1H = 'VEEG_DURING_SLEEP_CONSULTATION_1H',
    VeegDuringSleepConsultation2H = 'VEEG_DURING_SLEEP_CONSULTATION_2H',
    VeegDuringSleepConsultation6H = 'VEEG_DURING_SLEEP_CONSULTATION_6H',
    MigrationVisit = 'MIGRATION_VISIT',
    VeegOnStandbyConsultation = 'VEEG_ON_STANDBY_CONSULTATION',
    VeegDuringSleepConsultation = 'VEEG_DURING_SLEEP_CONSULTATION',
    PartnerConsultation = 'PARTNER_CONSULTATION'
}
/**
    * @export
    * @enum {string}
    */
export enum CarePlanPositionDtoPaymentMarkingEnum {
    WaitingForPayment = 'WAITING_FOR_PAYMENT',
    PaymentReceived = 'PAYMENT_RECEIVED'
}
/**
    * @export
    * @enum {string}
    */
export enum CarePlanPositionDtoTypeEnum {
    Referral = 'REFERRAL',
    Visit = 'VISIT'
}
/**
    * @export
    * @enum {string}
    */
export enum CarePlanPositionDtoVisitTypeEnum {
    Remote = 'REMOTE',
    Stationary = 'STATIONARY',
    Absent = 'ABSENT'
}


